const InputSecondaryComponent = ({ title, name, value, onBlur, onChange, type, disabled }: any) => {
    return (
        <div className="flex flex-col gap-[4px]">
            <label className="text-[#5C5C5C] text-xs font-normal" htmlFor="first_name">{title}</label>
            <input className="rounded-[7px] bg-[#F4F4F9] border border-[#5553] h-[40px] px-[10px]   text-secondaryText dark:!text-secondaryText text-sm font-normal disabled:hover:!border-[#5553] disabled:opacity-[0.6] hover:border-[#999] focus:border-[#999]" type={type} name={name} value={value} onBlur={onBlur} onChange={onChange} autoComplete="off" disabled={disabled} />
        </div>
    );
};

export default InputSecondaryComponent;